import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChatStatisticsResponse } from '../../../insight/interfaces/Dashboard/ChatStatisticsResponse';
import { CampaignResponse } from '../../interfaces/dashboard/CampaignResponse';
import { ChatChannelStatsResponse } from '../../interfaces/dashboard/ChatChannelStatsResponse';
import { GetChatDashboardStatsResponse } from '../../interfaces/dashboard/GetChatDashboardStatsResponse';
import { OnlineAgentResponse } from '../../interfaces/dashboard/OnlineAgentResponse';
import { RatingResponse } from '../../interfaces/dashboard/RatingResponse';
import { GetTranscriptWithTotalCount, TranscriptResponse } from '../../interfaces/dashboard/TranscriptResponse';
import { environment } from '@env/environment';
import { map } from 'rxjs';
import { getContext } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  apiUrl: string = '';
  constructor(private httpClient: HttpClient) {}

  getChatDashboardStats(from: string, to: string, campaignId: string) {
    const url = `/insights/getChatDashboardStats?From=${from}&To=${to}&CampaignId=${campaignId}`;
    return this.httpClient.get<GetChatDashboardStatsResponse>(url);
  }

  getChatStatistics(from: string, to: string, campaignId: string) {
    const url = `/insights/getChatStatistics?From=${from}&To=${to}&CampaignId=${campaignId}`;
    return this.httpClient.get<ChatStatisticsResponse>(url);
  }

  getChatChannelStats(from: string, to: string, campaignId: string) {
    const url = `/insights/getChatChannelStats?From=${from}&To=${to}&CampaignId=${campaignId}`;
    return this.httpClient.get<Array<ChatChannelStatsResponse>>(url);
  }

  // fetchRecentTranscripts(from: string, to: string, campaignId: string) {
  //   const pageNo = 0;
  //   const pageSize = 10;
  //   const url = `/conversation/getFilterConversations?PageNo=${pageNo}&PageSize=${pageSize}&From=${from}&To=${to}&CampaignId=${campaignId}`;
  //   return this.httpClient.get<Array<TranscriptResponse>>(url);
  // }

  fetchRecentTranscripts(from: string, to: string, pageNo: number, pageSize: number, skip: number, campaignId: string) {
    let url = `/conversation/getFilterConversations?From=${from}&To=${to}&PageNo=${pageNo}&PageSize=${pageSize}&Skip=${skip}`;

    if (campaignId) {
      url += `&CampaignId=${campaignId}`;
    }

    return this.httpClient.get<GetTranscriptWithTotalCount>(url).pipe(
      map((data: GetTranscriptWithTotalCount) => {
        return {
          totalCount: data.TotalCount,
          transcripts: data.Transcripts.map((d: TranscriptResponse) => {
            return {
              id: d.Id,
              visitor_id: d.VisitorId,
              campaign_id: d.CampaignId,
              conversation_sid: d.ConversationSid,
              campaign_name: d.Campaign.name,
              friendly_name: d.FriendlyName,
              nick_name: d.NickName,
              has_rated: d.HasRated,
              rating: d.Rating,
              created_on: d.DateCreated,
              date_closed: d.DateClosed,
              status: d.Status,
              channel_type: d.Site.entry_type,
              conversation_type: d.ConversationType,
              message_count: d.MessageCount,
              customer_message_count: d.CustomerMessagesCount,
              agent_message_count: d.AgentMessagesCount,
              customer_info: d.CustomerInfo,
              agent_info: d.AgentInfo,
              disposition: d.Disposition,
              profile_pic: d.ProfilePic,
              note: d.Note,
              returning_visitor: d.ReturningVisitor,
              action: d.Id,
              site: d.Site,
            };
          }),
        };
      })
    );
  }

  fetchConversationRating(conversationSid: string) {
    const url = `/ratings?ConversationSid=${conversationSid}`;
    return this.httpClient.get<RatingResponse>(url);
  }

  forceAwayAgent(userId: string) {
    const url = `/user/forceLogout`;
    return this.httpClient.post(url, { UserId: userId }, { context: getContext('messenger') });
  }

  getAllCampaigns(pageNo: number, pageSize: number, sortColumn: string, sortValue: string) {
    const url = `/campaigns?PageNo=${pageNo}&PageSize=${pageSize}&SortColumn=${sortColumn}&Sort=${sortValue}`;
    return this.httpClient.get<Array<CampaignResponse>>(url, { context: getContext('messenger') });
  }

  hasPendingChats(userId: string) {
    const url = `/Conversations/hasPendingChats?UserId=${userId}`;
    return this.httpClient.get<boolean>(url, { context: getContext('messenger') });
  }
}
